document.addEventListener("DOMContentLoaded", () => {
  const scrollIndicators = document.querySelectorAll('.scroll-indicator');  
  scrollIndicators.forEach(scrollIndicator => scrollIndicator.addEventListener('scroll', () => scrollIndicatorHide(event)));

  function scrollIndicatorHide(event) {
    let target = event.target || event.srcElement;
    target.classList.remove("scroll-indicator");
  }
});